import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCashRegister, faSync, faLock, faMoneyBillWave, faExchangeAlt, faGlobe, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useCaja } from './CajaContext';
import moneda from '../moneda';
import CerrarCajaModal from './CerrarCajaModal';

export default function CajaBar() {
    const { caja, refrescarCaja } = useCaja();
    const [mostrarCerrar, setMostrarCerrar] = useState(false);
    const [segundosLocales, setSegundosLocales] = useState(0);

    useEffect(() => {
        setSegundosLocales(0);
        if (!caja?.segundosAbierta && caja?.segundosAbierta !== 0) return;
        const interval = setInterval(() => setSegundosLocales(s => s + 60), 60000);
        return () => clearInterval(interval);
    }, [caja?.idCaja, caja?.segundosAbierta]);

    const totalSegundos = (caja?.segundosAbierta || 0) + segundosLocales;
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const tiempoAbierta = `${horas}h ${minutos}m`;

    useEffect(() => {
        const interval = setInterval(refrescarCaja, 60000);
        return () => clearInterval(interval);
    }, [refrescarCaja]);

    if (!caja) return null;

    const fmt = (n) => Number(n || 0).toLocaleString('es-AR');

    return (
        <>
            <div style={{
                background: 'linear-gradient(135deg, #28a745, #20c997)',
                color: '#fff',
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'wrap',
                boxShadow: '0 2px 8px rgba(40,167,69,0.3)',
                fontSize: '13px',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700 }}>
                    <FontAwesomeIcon icon={faCashRegister} /> Caja abierta · {tiempoAbierta}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FontAwesomeIcon icon={faUsers} /> {caja.miembros?.length ? caja.miembros.map(m => m.nombre).join(', ') : (caja.nombreTrabajador || '—')}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    Inicio: <strong>{moneda} {fmt(caja.montoInicial)}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FontAwesomeIcon icon={faMoneyBillWave} /> Efectivo: <strong>{moneda} {fmt(caja.ventasEfectivo)}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FontAwesomeIcon icon={faExchangeAlt} /> Transferencia: <strong>{moneda} {fmt(caja.ventasTransferencia)}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    Pedidos: <strong>{caja.totalPedidos || 0}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FontAwesomeIcon icon={faGlobe} /> Pedidos Web: <strong>{caja.pedidosWebTotal || 0}</strong>
                    {caja.pedidosWebPendientes > 0 && (
                        <span style={{ background: '#ffc107', color: '#212529', padding: '2px 6px', borderRadius: '10px', fontSize: '11px', fontWeight: 700 }}>
                            {caja.pedidosWebPendientes} pendiente{caja.pedidosWebPendientes > 1 ? 's' : ''}
                        </span>
                    )}
                </div>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                    <button
                        onClick={refrescarCaja}
                        title='Refrescar'
                        style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer' }}
                    >
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                    <button
                        onClick={() => setMostrarCerrar(true)}
                        style={{
                            background: '#fff', color: '#dc3545', border: 'none',
                            padding: '6px 14px', borderRadius: '6px', cursor: 'pointer',
                            fontWeight: 700, fontSize: '13px',
                        }}
                    >
                        <FontAwesomeIcon icon={faLock} /> Cerrar caja
                    </button>
                </div>
            </div>

            {mostrarCerrar && <CerrarCajaModal onClose={() => setMostrarCerrar(false)} />}
        </>
    );
}
